import moment from 'moment';
import { LunchBreakItem } from 'utils/normalizeEventBreak';

const checkLunchBreakAndWorkingHour = ({
  type,
  value,
  lunchBreaks,
}: {
  type: 'start' | 'end';
  value: string;
  lunchBreaks: LunchBreakItem;
}) => {
  const result = {
    isStartLaterThanLunchBreakStart: false,
    isEndEarlierThanLunchBreakEnd: false,
  };

  const isLunchBreakValid = lunchBreaks.startFirst && lunchBreaks.endFirst;

  if (!isLunchBreakValid) return result;

  if (type === 'start') {
    const isStartLaterThanLunchBreakStart = moment(value, 'HH:mm:ss').isAfter(
      moment(lunchBreaks.startFirst, 'HH:mm:ss')
    );

    result.isStartLaterThanLunchBreakStart = isStartLaterThanLunchBreakStart;
  }

  if (type === 'end') {
    const isEndEarlierThanLunchBreakEnd = moment(value, 'HH:mm:ss').isBefore(
      moment(lunchBreaks.endFirst, 'HH:mm:ss')
    );

    result.isEndEarlierThanLunchBreakEnd = isEndEarlierThanLunchBreakEnd;
  }

  return result;
};

export default checkLunchBreakAndWorkingHour;
